'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import { OLAF, CALYPSO, OZ } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment } from 'react';
import styled from 'styled-components';
import Tabs from './Tabs';
import breakpoint from '../../utils/responsiveBreakpoints';
const PricingPageTitle = styled.h1.withConfig({
  displayName: "TabLayout__PricingPageTitle",
  componentId: "sc-1gkoxvw-0"
})(["font-size:28px;color:", ";", ""], OLAF, breakpoint.tablet(_t || (_t = _`
    font-size: 34px;
  `)));
const PricingPageSubtitle = styled.p.withConfig({
  displayName: "TabLayout__PricingPageSubtitle",
  componentId: "sc-1gkoxvw-1"
})(["font-size:14px;color:", ";.pricing-page-subtitle-link{text-decoration:underline;color:", ";}", ";"], OLAF, OLAF, breakpoint.tablet(_t2 || (_t2 = _`
    font-size: 16px;
  `)));
const HeaderTitle = styled.div.withConfig({
  displayName: "TabLayout__HeaderTitle",
  componentId: "sc-1gkoxvw-2"
})(["text-align:center;", ""], breakpoint.phone(_t3 || (_t3 = _`
    padding: 0 15px;
  `)));
const HeaderGradient = styled.div.withConfig({
  displayName: "TabLayout__HeaderGradient",
  componentId: "sc-1gkoxvw-3"
})(["position:absolute;z-index:-100;background-color:#00bda5;background-image:linear-gradient( -303deg,", ",0%,#00afb2 56%,", " 100% );width:100%;height:100%;"], CALYPSO, OZ);

const HeaderBackdrop = () => {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(HeaderGradient, {}), /*#__PURE__*/_jsxs(HeaderTitle, {
      className: "m-auto-y-0",
      children: [/*#__PURE__*/_jsx(PricingPageTitle, {
        className: "p-top-8 p-bottom-2 m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.title"
        })
      }), /*#__PURE__*/_jsx(PricingPageSubtitle, {
        className: "p-bottom-8 m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.subTitle"
        })
      })]
    })]
  });
};

const TabLayout = ({
  selectedPrimaryTab,
  selectedSecondaryTab,
  children
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(HeaderBackdrop, {}), /*#__PURE__*/_jsx(Tabs, {
      selectedPrimaryTab: selectedPrimaryTab,
      selectedSecondaryTab: selectedSecondaryTab
    }), children]
  });
};

export default TabLayout;